// -------------- ORDER Page --------------
import {USER_SET_ALL_FOR_EXCEL} from "./userActions";

export const ORDER_FIELD_ERROR       = 'ORDER_FIELD_ERROR';
export const ORDER_FIELD_RESET_ERROR = 'ORDER_FIELD_RESET_ERROR';
export const ORDER_SET_ITEM          = 'ORDER_SET_ITEM';
export const ORDER_GET_ITEM          = 'ORDER_GET_ITEM';
export const ORDER_SET_ALL           = 'ORDER_SET_ALL';
export const ORDER_SET_ALL_FOR_EXCEL = 'ORDER_SET_ALL_FOR_EXCEL';
export const ORDER_ADD_ITEM          = 'ORDER_ADD_ITEM';
export const ORDER_ITEM_ID           = 'ORDER_ITEM_ID';
export const ORDER_ASSIGN_ITEM       = 'ORDER_ASSIGN_ITEM';
export const ORDER_CREATED_USER      = 'ORDER_CREATED_USER';
export const INVOICE_SET_ITEM        = 'INVOICE_SET_ITEM';
export const INVOICE_GET_ITEM        = 'INVOICE_GET_ITEM';
export const INVOICE_ADD_ITEM        = 'INVOICE_ADD_ITEM';
export const INVOICE_SET_ALL         = 'INVOICE_SET_ALL';



// --------- ORDER Page ---------
export function orderFieldError(field, fieldData = {}) {
    return { type: ORDER_FIELD_ERROR, fieldName: field, fieldData: fieldData }
}
export function orderFieldResetError(field, fieldData = {}) {
    return { type: ORDER_FIELD_RESET_ERROR }
}
export function orderGetItem(targetItem) {
    return { type: ORDER_GET_ITEM, data: targetItem }
}
export function orderSetItem(targetItem) {
    return { type: ORDER_SET_ITEM, data: targetItem }
}
export function orderAddItem(addItem) {
    return { type: ORDER_ADD_ITEM, data: addItem }
}
export function orderSetList(allORDER) {
    return { type: ORDER_SET_ALL, data: allORDER }
}
export function orderSetListForExcel(allUSER) {
    return { type: USER_SET_ALL_FOR_EXCEL, data: allUSER }
}
export function orderItemId(item) {
    return { type: ORDER_ITEM_ID, data: item }
}
export function orderGetAssignItem(item) {
    return { type: ORDER_ASSIGN_ITEM, data: item }
}
export function orderCreatedUser(item) {
    return { type: ORDER_CREATED_USER, data: item }
}
export function invoiceGetItem(targetItem) {
    return { type: INVOICE_GET_ITEM, data: targetItem }
}
export function invoiceSetItem(targetItem) {
    return { type: INVOICE_SET_ITEM, data: targetItem }
}
export function invoiceAddItem(addItem) {
    return { type: INVOICE_ADD_ITEM, data: addItem }
}
export function invoiceSetList(allORDER) {
    return { type: INVOICE_SET_ALL, data: allORDER }
}
